import { render, staticRenderFns } from "./MailRegistrationForm.vue?vue&type=template&id=67bcec03&"
import script from "./MailRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./MailRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./MailRegistrationForm.vue?vue&type=style&index=0&id=67bcec03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports